import styles from "./Toast.module.css";

type ToastProps = {
  text: string | null;
};

// 自绘轻提示，对齐设计稿 .toast（tokens.css）；显示/隐藏由调用方控制
const Toast = ({ text }: ToastProps) => {
  if (!text) return null;
  return <div className={styles.toast}>{text}</div>;
};

export default Toast;
